import React from "react";
import PropTypes from "prop-types";
import TitleBar from "../Layout/titleBar";
import { Row, Col } from "react-flexbox-grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import DragAndDrop from "../Common/dragAndDrop";
import SearchableMultiSelect from "../Common/searchableMultiSelect";
import "./styles.css";

class ContenidoEditado extends React.Component {
  render() {
    return (
      <div>
        {/* menú superior */}
        <TitleBar
          title={"Editar contenido"}
          handleOnCancel={this.props.handleOnCancel}
          cancelarButtonLink="/Contenido"
          handleOnSave={this.props.handleOnSave}
          searchPlaceholder="Contenido"
        />

        <Row>
          <Col md={6}>
            <Paper className="myBox no-margin">
              <TextField
                className="myInput"
                label="Tipo Contenido"
                select
                error={this.props.error && this.props.error.tipoContenido}
                helperText={
                  this.props.error && this.props.error.tipoContenido
                    ? this.props.error.tipoContenido
                    : ""
                }
                name="idTipoContenido"
                fullWidth
                required
                disabled
                value={this.props.idTipoContenido}
                onChange={this.props.handleOnChange}
                InputLabelProps={{
                  shrink: this.props.idTipoContenido !== "" && this.props.idTipoContenido !== null,
                }}
              >
                {this.props.tiposContenido &&
                  this.props.tiposContenido.map((tc) => (
                    <MenuItem key={tc.idTipoContenido} value={tc.idTipoContenido}>
                      {tc.nombre}
                    </MenuItem>
                  ))}
              </TextField>
            </Paper>
          </Col>

          <Col md={6}>
            <Paper className="myBox no-margin">
              <TextField
                className="myInput"
                label={`Nombre`}
                name="nombre"
                InputLabelProps={{ shrink: true }}
                fullWidth
                required
                error={this.props.error && this.props.error.nombre}
                helperText={
                  this.props.error && this.props.error.nombre ? this.props.error.nombre : ""
                }
                value={this.props.nombre}
                onChange={this.props.handleOnChange}
              />
            </Paper>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            {this.props.tipoContenidoSelected &&
            this.props.tipoContenidoSelected.nombre === "Preguntas frecuentes" ? null : (
              <Paper className="myBox no-margin">
                <TextField
                  className="myInput"
                  name="startDate"
                  label="Fecha de inicio"
                  InputLabelProps={{ shrink: true, required: true }}
                  type="date"
                  value={this.props.fechaActivacion}
                  onChange={(e) => this.props.handleOnClickDia({ fechaActivacion: e.target.value })}
                  InputProps={{ inputProps: { max: "9999-12-31" } }}
                />
              </Paper>
            )}
          </Col>
          <Col md={6}>
            {this.props.tipoContenidoSelected &&
            this.props.tipoContenidoSelected.nombre === "Preguntas frecuentes" ? null : (
              <Paper className="myBox no-margin">
                <TextField
                  className="myInput"
                  name="endDate"
                  label="Fecha de finalización"
                  InputLabelProps={{ shrink: true, required: true }}
                  type="date"
                  error={this.props.error && this.props.error.fecha}
                  helperText={
                    this.props.error && this.props.error.fecha ? this.props.error.fecha : ""
                  }
                  value={this.props.fechaDesactivacion}
                  onChange={(e) =>
                    this.props.handleOnClickDia({ fechaDesactivacion: e.target.value })
                  }
                  InputProps={{ inputProps: { max: "9999-12-31" } }}
                />
              </Paper>
            )}
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {this.props.tipoContenidoSelected &&
            this.props.tipoContenidoSelected.nombre === "Preguntas frecuentes" ? (
              <Paper className="myBox no-margin">
                <TextField
                  label={`Respuesta`}
                  name="textoLargo"
                  multiline={true}
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  required
                  error={this.props.error && this.props.error.textoLargo}
                  helperText={
                    this.props.error && this.props.error.textoLargo
                      ? this.props.error.textoLargo
                      : ""
                  }
                  value={this.props.textoLargo}
                  onChange={this.props.handleOnChange}
                />
              </Paper>
            ) : (
              <>
                <DragAndDrop
                  accept="image/jpeg, image/png, image/gif"
                  message="Arrastra la imagen o"
                  messageBottom={
                    this.props.tipoContenidoSelected
                      ? this.props.tipoContenidoSelected.observacion
                      : undefined
                  }
                  handleOnDrop={this.props.handleOnDropFile}
                  multiple={false}
                />
                <p style={{ color: "red", fontSize: 16, textAlign: "center" }}>
                  {this.props.error && this.props.error.imagen}
                </p>
              </>
            )}
          </Col>
        </Row>

        {this.props.tipoContenidoSelected &&
        this.props.tipoContenidoSelected.nombre === "Preguntas frecuentes"
          ? null
          : this.props.pathImg != null && (
              <Row>
                <Col md={12}>
                  <div className="containerArchivoSubido">
                    <img
                      alt=""
                      style={{ maxWidth: "80%", maxHeight: "500px" }}
                      src={this.props.pathImg}
                    ></img>
                  </div>
                </Col>
              </Row>
            )}

        {/* Asociar a ofertas segmentadas — solo para banners */}
        {this.props.tipoContenidoSelected &&
          this.props.tipoContenidoSelected.nombre !== "Preguntas frecuentes" &&
          this.props.ofertasActivas &&
          this.props.ofertasActivas.length > 0 && (
            <Row>
              <Col md={12}>
                <Paper className="myBox no-margin">
                  <SearchableMultiSelect
                    label="Asociar a ofertas (opcional)"
                    searchLabel="Buscar oferta por nombre o tag"
                    options={this.props.ofertasActivas || []}
                    value={this.props.ofertasAsociadas || []}
                    onChange={this.props.handleOfertasAsociadasChange}
                    getOptionValue={(oferta) => oferta.idOferta}
                    getOptionLabel={(oferta) =>
                      `${oferta.nombre}${oferta.tag ? ` (${oferta.tag})` : ""}`
                    }
                    helperText="Si no se asocia a ninguna oferta, el banner se mostrará a todos los usuarios."
                  />
                </Paper>
              </Col>
            </Row>
          )}
      </div>
    );
  }
}

ContenidoEditado.propTypes = {
  handleOnSearch: PropTypes.func,
  tipoContenidoSelected: PropTypes.object.isRequired,
  tiposContenido: PropTypes.array.isRequired,
  itemTipoContenidoSelected: PropTypes.object,
  contenidos: PropTypes.array.isRequired,
  openModalVer: PropTypes.bool,
  itemSelectedVer: PropTypes.object,
  itemSelectedEditar: PropTypes.object,
  openModalBorrar: PropTypes.bool,
  handleOnChangeTipoContenido: PropTypes.func.isRequired,
  handleOnClickBuscar: PropTypes.func.isRequired,
  handleOnClickVer: PropTypes.func.isRequired,
  handleOnClickEditar: PropTypes.func.isRequired,
  handleOnClickBorrar: PropTypes.func.isRequired,
  handleOnClickCerrarModal: PropTypes.func.isRequired,
  handleOnSwap: PropTypes.func.isRequired,
};

ContenidoEditado.defaultProps = {
  tiposContenido: [],
  contenidos: [],
  canSwap: true,
  openModalVer: false,
  itemSelectedVer: undefined,
  itemSelectedEditar: [],
  handleOnChangeTipoContenido: (f) => f,
  handleOnClickBuscar: (f) => f,
  handleOnSearch: (f) => f,
  handleOnClickVer: (f) => f,
  handleOnClickEditar: (f) => f,
  handleOnClickBorrar: (f) => f,
  handleOnClickCerrarModal: (f) => f,
  handleOnSwap: (f) => f,
};

export default ContenidoEditado;
